/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

/** dashboard(Homepage or pages) view,edit,delete,create */

export const LoginAPI = "/authenticate/signIn";
export const LoginWithMFAAPI = "/authenticate/signInUsingMFA";
export const LoginWithTWOFAAPI = "/authenticate/signInUsingTwoFA";
export const SendTwoFASignInCode = "/authenticate/sendSignInCode";
export const ForgotPasswordAPI = "/authenticate/forgotPassword";
export const ForgotPasswordCideAPI = "/authenticate/resetPasswordUsingCode";
export const UserDetails = "/user/detail";
export const CreateUser = "/onboard/signup/newUser";
export const GetUserApps = "/user/apps";
export const GetUserRoles = "/admin/roles";
export const AssignUserRoles = "/admin/assignRoles";
export const EnableUserAndAssignRole = "/admin/enableUserAndAssignRole";
export const ActivateUser = "/admin/approveUser";
export const forcePassChange = "/authenticate/forcePasswordChange";
export const associateGoogleTOTP = "/authenticate/resetMFA";
export const associateGoogleOTPRegen = "/authenticate/associateGoogleRawImage";
export const EnableUser = "/admin/enableUser";
export const ArchiveUser = "/admin/archiveUser";
export const ValidateGoogleTOTP = "/authenticate/validateGoogleTOTP";
export const GetSelectedUserDetails = "/admin/user/";
export const LogoutUser = "/user/logout";
export const ResetPassword = "/authenticate/changePassword";
export const JobFunction = "/onboard/signup/jobFunction";
export const CountriesList = "/onboard/signup/countries";
export const DownloadUserCSV = "/admin/sampleCSV";
export const UploadUserCSV = "/admin/bulkUserUpload";

export const MonitorENV = "/tools/status";
export const MultipleUserEnrolment = "/onboard/createAndApproveUser";
export const RolePermission = "/user/permissions"
export const PostAllUsersAPI = "/admin/users";
export const RejectUsersAPI = "/admin/rejectUser";
export const DownloadUserData = "/admin/download/csv";

export const GetUserEmail = "/admin/emailById";
export const ForceResetUser = "/admin/forceResetUser";

export const GetSubscriptionRequest = "/admin/getSubscriptionRequest";
export const CreateGuestUser = "/onboard/signup/signInAsGuest";
export const GuestDesktopLogin = "/onboard/signup/guestDesktopLogin";
export const ApproveSubscription = "/admin/approveSubscription";
export const RejectSubscription = "/admin/rejectSubscriptionUser";
export const GetUserIDandPassword = "/authenticate/decryptLogin";
export const HeartBeat = "/admin/heartbeat";
export const InvalidateToken = "/user/invalidateToken";
export const UpdateTrialDaysRequest = "/admin/extendTrialDays";
export const usersReport = '/admin/usersReport';
export const userLockReset = '/admin/userLockReset';
export const FetchTeams = '/team/teams';
export const CreateOrUpdateTeam = '/team/createOrUpdateTeam';
export const payGUserReport = '/admin/usersPAYGReport';
export const ChangeTeam = "/admin/changeTeam";
export const ExtendSubscriptionExpiration = "/admin/extendSubscriptionExpiration";
export const UserFeature = "/admin/userFeature";
export const ChangePAYGCredit = "/admin/changePAYGCredit";
export const EnableUserTracker = "/user/updateUser/"
export const SSOAuthentication = '/authenticate/ssoSignIn';
export const SSOUserQueueInfo = '/stanford/queue';
export const EncryptData = "/webhooks/fastspring/encrypt-session";
export const CheckSubscriptionStatus = "/integration/checkSubscriptionStatus";
export const GoogleSignIn = "/authenticate/googleSignIn";
export const DeactivateSubscription = "/subscriptions/deactivate";
export const CancelDeactivationRequest = "/subscription/cancel-deactivation-request";
export const GetConfigByRole = "/admin/roles";

/** Admin Client Provisioning */
export const AdminClients = "/admin/clients";
export const AdminClientById = (clientId: number) => `/admin/clients/${clientId}`;

/** Admin API Key Management */
export const AdminApiKeys = "/admin/api-keys";
export const AdminApiKeysRotate = "/admin/api-keys/rotate";
export const AdminApiKeysRevoke = "/admin/api-keys/revoke";

/** Admin Usage / Billing */
export const AdminUsageUser = (userId: number) => `/admin/usage/user/${userId}`;
export const AdminUsageTeam = (teamId: number) => `/admin/usage/team/${teamId}`;
export const AdminUsageSummary = "/admin/usage/summary";

/** Admin MCP Subscriptions */
export const AdminMcpSubscriptions = "/admin/mcp-subscriptions";
export const AdminMcpSubscriptionById = (subscriptionId: number) => `/admin/mcp-subscriptions/${subscriptionId}`;
export const AdminMcpSubscriptionsByClient = (clientId: number) => `/admin/mcp-subscriptions/client/${clientId}`;
export const AdminMcpSubscriptionCancel = (subscriptionId: number) => `/admin/mcp-subscriptions/${subscriptionId}/cancel`;